import { AddIcon, ButtonV2 } from '@medeloop/medeloop-components-library';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import { PageHeader } from 'src/components';
import { selectAccount } from 'src/store/selectors';
import { UserGroup } from 'src/types/users';

export function StudiesPage() {
  const navigate = useNavigate();
  const account = useSelector(selectAccount);

  return (
    <section className="flex flex-col max-w-right-section mx-auto px-6 xl:px-0">
      <div className="flex justify-between items-center mb-6">
        <PageHeader
          title="Studies"
          description="Design, organize, and track research studies or projects"
        />
        {account.groups.includes(UserGroup.ADMIN) && (
          <ButtonV2
            variant="primary"
            onClick={() => {
              navigate('create');
            }}
          >
            <AddIcon />
            Create study
          </ButtonV2>
        )}
      </div>
      <Outlet />
    </section>
  );
}
